import { LanguageEnum } from '@modules/lang-module/enums/language.enum'
import { TUI_ENGLISH_LANGUAGE, TUI_RUSSIAN_LANGUAGE, TuiLanguage } from '@taiga-ui/i18n'

export const LanguagesTaiga: Record<LanguageEnum, TuiLanguage> = {
	[LanguageEnum.ENGLISH]: TUI_ENGLISH_LANGUAGE,
	[LanguageEnum.RUSSIAN]: TUI_RUSSIAN_LANGUAGE,
}
